export const PARTICIPANTS_ROUTER_ROOT = '/participants';
export const PARTICIPANTS_ROUTER_NEW = PARTICIPANTS_ROUTER_ROOT + '/new';
export const PARTICIPANTS_ROUTER_EDIT = PARTICIPANTS_ROUTER_ROOT + '/edit/:id';



// WEBPACK FOOTER //
// ./src/components/Participants/constants.js